import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { FiAward, FiDownload } from "react-icons/fi";
import { getType } from "../../actions/studensts";
import UNAUTHORIZED from "../UNAUTHORIZED";
import StudentList from "../StudentList";
import { excelActOne, excelActTwo } from "../exportToExcel";

export default function ScoreHandler() {
  const dispatch = useDispatch();
  const location = useLocation();
  const studentType = useLocation().pathname.split("/")[3];
  const { students } = useSelector((state) => state.students);
  const [search, setSearch] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const [loading, setLoading] = useState(false);
  const count = useSelector((state) => state.students.count);
  const { role, username } = JSON.parse(localStorage.getItem("profile")).value[0];

  useEffect(() => {
    dispatch({ type: "CLEAR" });
    if (!hasSearched) return;
    const state = convertType(studentType);
    const timeOutId = setTimeout(() => {
      if (search && search.trim() !== "") {
        dispatch(getType("scorehandler", state, search));
      } else {
        dispatch(getType("scorehandler", state, ""));
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [location, search, dispatch, studentType, hasSearched]);

  useEffect(() => {
    setHasSearched(false);
  }, [location]);

  useEffect(() => {
    if (students) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [students]);

  const pageTitle =
    studentType === "new"
      ? "Score Request"
      : studentType === "score_pending"
      ? "Score Pending"
      : studentType === "score_validation"
      ? "Score Validation"
      : "Score Handler";

  const canExport =
    studentType === "new" &&
    (role === "admin" || role === "auditor");

  return (
    <div>
      {!["admin", "auditor", "agent"].includes(role) ? (
        <UNAUTHORIZED />
      ) : (
        <div className="min-h-screen px-4 sm:px-8 py-6">
          {/* Page Header */}
          <div className="mb-8 flex flex-wrap items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-xl bg-indigo-600/20 border border-indigo-500/30 flex items-center justify-center shrink-0">
                <FiAward className="text-indigo-400 text-xl" />
              </div>
              <div>
                <h1 className="text-3xl font-bold text-white tracking-tight">{pageTitle}</h1>
                <p className="text-slate-400 text-sm mt-0.5">Manage score handler students</p>
              </div>
            </div>

            {canExport && (
              <div className="flex gap-3">
                <button
                  type="button"
                  onClick={excelActOne}
                  className="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-500 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors shadow"
                >
                  <FiDownload size={14} /> Export ACT1
                </button>
                <button
                  type="button"
                  onClick={excelActTwo}
                  className="flex items-center gap-2 bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors shadow"
                >
                  <FiDownload size={14} /> Export ACT2
                </button>
              </div>
            )}
          </div>

          {/* Content */}
          <div className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm p-6 shadow">
            <StudentList
              setSearch={(val) => {
                setSearch(val);
                setHasSearched(true);
              }}
              students={students}
              search={search}
              loading={loading}
              count={count}
            />
          </div>
        </div>
      )}
    </div>
  );
}

function convertType(studentType) {
  switch (studentType) {
    case "score_validation":
      return "score_validation";
    case "new":
      return "score_request";
    case "score_pending":
      return "score_pending";
    default:
      return "score_validation";
  }
}
